import { heroStats } from '@/mocks/home';

export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20digital%20illustration%20of%20entertainment%20community%20and%20social%20media%20buzz%2C%20warm%20coral%20orange%20and%20deep%20amber%20color%20palette%2C%20modern%20editorial%20design%20aesthetic%2C%20flowing%20geometric%20shapes%20and%20waves%2C%20soft%20gradient%20blends%2C%20dynamic%20energy%2C%20no%20text%2C%20clean%20atmospheric%20background&width=1920&height=900&seq=hero-bg-91&orientation=landscape"
          alt="91黑料吃瓜 - 吃瓜社区聚集地"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 hero-overlay"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-white/90 text-sm font-medium">实时更新 · 全网最快爆料</span>
            </div>

            <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-4 font-heading">
              91黑料吃瓜 · 吃瓜群众聚集地
            </h1>

            <p className="text-white/80 text-lg md:text-xl mb-3 font-heading">
              全网最全爆料平台，第一时间掌握娱乐圈真相
            </p>

            <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              91黑料吃瓜是国内领先的吃瓜社区，汇聚368万吃瓜群众，每日更新200+独家爆料内容。
              从明星动态到综艺内幕，从饭圈八卦到娱乐圈深度分析，这里有你想要的一切吃瓜福利。
              多位资深娱评人与匿名爆料人持续供稿，确保每一条信息都新鲜热辣、真实可信。
            </p>
            <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              当前正在进行「2026娱乐圈半年盘点」专题，多篇独家深度报道正在连载中，不要错过。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-accent-400 text-2xl md:text-3xl font-bold font-heading">
                    {stat.value}
                  </div>
                  <div className="text-white/60 text-xs mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => handleScrollTo(e, '#topics')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-full text-base whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-fire-line text-lg"></i>
                立即围观热门话题
              </a>
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium px-8 py-3.5 rounded-full text-base whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/20"
              >
                <i className="ri-flashlight-line text-lg"></i>
                查看最新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20editorial%20illustration%20of%20digital%20gossip%20community%20and%20social%20media%20trending%20topics%2C%20warm%20coral%20orange%20and%20amber%20color%20palette%2C%20modern%20minimalist%20design%2C%20layered%20geometric%20shapes%20with%20soft%20gradients%2C%20dynamic%20flowing%20composition%2C%20warm%20atmospheric%20lighting%2C%20editorial%20magazine%20quality&width=600&height=750&seq=hero-visual-91&orientation=portrait"
                alt="91黑料吃瓜 - 热门爆料内容与吃瓜社区"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <span className="bg-primary-500 text-white px-2 py-0.5 rounded-full text-xs font-medium">HOT</span>
                  <span>2026娱乐圈半年盘点 · 火热连载中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}